import moment from "moment-timezone";
import { capitalizeFirstLetter } from "./excelUtils";

export const formatTextToPhone = (text) => {
  const x = text.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
  //debugger;
  return !x[2] ? x[1] : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ""}`;
};

export const formatTextToLinePhone = (text) => {
  const x = text.replace(/\D/g, "").match(/(\d{0,3})(\d{0,3})(\d{0,4})(\d{0,6})/);
  return !x[2] ? x[1] : `(${x[1]}) ${x[2]}${x[3] ? `-${x[3]}` : ""}${x[4] ? `-${x[4]}` : ""}`;
};

export const formatXml = (xml: string | undefined, tab = "\t") => {
  if (!xml) return "";
  // tab = optional indent value, default is tab (\t)
  let formatted = "";
  let indent = "";

  xml.split(/>\s*</).forEach(function (node) {
    if (node.match(/^\/\w/)) indent = indent.substring(tab.length); // decrease indent by one 'tab'
    formatted += `${indent}<${node}>\r\n`;
    if (node.match(/^<?\w[^>]*[^/]$/)) indent += tab; // increase indent
  });
  return formatted.substring(1, formatted.length - 3);
};

export const titleCase = (str) => {
  return str.toLowerCase().replace(/\b(\w)/g, (s) => s.toUpperCase());
};

export const getRandomString = (length = 10) => {
  let result = "";
  const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const generateFileName = (format: any) => {
  const date = moment(new Date()).format("YYYYMMDD");
  const urlArr = location.pathname.split("/");
  const path =
    urlArr.length > 2
      ? urlArr
          .filter((_, i) => i !== 0)
          .join(",")
          .replace(",", "_")
      : urlArr[urlArr.length - 1];

  const screenName = path?.includes("_")
    ? path
        ?.split("_")
        ?.map((i) => capitalizeFirstLetter(i).replace("_", "-"))
        ?.join("-")
    : capitalizeFirstLetter(path);

  return `${screenName}-${date}.${format}`;
};

export const getLogoMimeType = (logoFileType: any) => {
  let dataType = "";
  switch (logoFileType) {
    case "image/png":
      dataType = "data:image/png;base64,";
      break;
    case "image/jpeg":
      dataType = "data:image/jpeg;base64,";
      break;
    case "image/jpg":
      dataType = "data:image/jpg;base64,";
      break;
    case "image/svg+xml":
      dataType = "data:image/svg+xml;base64,";
      break;
    default:
      console.error("Unknown Logo Type", logoFileType);
      break;
  }

  return dataType;
};

export const toTitleLabel = (input: string): string => {
  return input
    .replace(/([a-z])([A-Z])/g, "$1 $2") // camelCase → space
    .replace(/[_\s]+/g, " ")
    .trim()
    .split(" ")
    .filter(Boolean)
    .map((word) => {
      if (word.toLowerCase() === "id") return "ID";
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    })
    .join(" ");
};

export const truncate = (text: string, maxLength: number) =>
  text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
